import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface NavigationLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  isExternal?: boolean;
}

const NavigationLink: React.FC<NavigationLinkProps> = ({ 
  to, 
  children, 
  className = '', 
  onClick,
  isExternal = false
}) => {
  const baseClasses = "text-gray-600 hover:text-primary transition-colors duration-300";
  const combinedClasses = `${baseClasses} ${className}`;
  const { i18n } = useTranslation();
  
  // Extraire le préfixe de langue actuel
  const currentLang = i18n.language || 'fr';

  // Si le lien commence par '#', c'est un lien d'ancrage
  const isAnchor = to.startsWith('#');
  
  if (isAnchor) {
    return (
      <a 
        href={to} 
        className={combinedClasses}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }
  
  if (isExternal) {
    return (
      <a 
        href={to} 
        className={combinedClasses}
        onClick={onClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }
  
  // Si le lien ne commence pas par '/' ou est déjà préfixé par la langue, on l'utilise tel quel
  // Sinon, on ajoute le préfixe de langue
  const linkTo = !to.startsWith('/') || to.match(/^\/[a-z]{2}\//)
    ? to
    : `/${currentLang}${to}`;
  
  return (
    <Link 
      to={linkTo} 
      className={combinedClasses}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

export default NavigationLink;
